var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Home")]),_c('li',[_vm._v("About Us")]),_c('li',[_vm._v("Contact Us")])])}]

export { render, staticRenderFns }